
import { MottagningsplatsDTO } from "~app/common/models/styrtabeller/MottagningsplatsDTO";
import { StyrtabellRedovisningshanvisningHandelssortimentDto } from "~app/features/administration/regelverk-viol3/regelverkViol3.models";
import { BefraktareDto } from "./BefraktareDto";
import { StyrtabellLanKommunDistriktDTO } from "./StyrtabellLanKommunDistriktDTO";
import { StyrtabellVerksamhetsomradeDTO } from "./StyrtabellVerksamhetsomradeDTO";

export class StyrtabellRedovisningshanvisningDto   {

    id: number;
    guid: string;
    mottagningsplats: MottagningsplatsDTO;
    mottagningsplatsId?: number;
    inmatningshandelssortiment: string;
    ersattningsrad: boolean;
    befraktare: BefraktareDto;
    anskaffningsform: string[];
    affarsform: string[];
    avverkningsform: string;
    namn: string;
    transportslag: string;
    kontraktstyp: string;
    verksamhetsomraden: StyrtabellVerksamhetsomradeDTO[];
    lanKommunDistrikt: StyrtabellLanKommunDistriktDTO[];
    styrtabellRedovisningshanvisningar: StyrtabellRedovisningshanvisningHandelssortimentDto[];

    constructor() {
        this.id = undefined;
        this.guid = undefined;
        this.befraktare = undefined;
        this.mottagningsplats = undefined;
        this.mottagningsplatsId = undefined;
        this.inmatningshandelssortiment = undefined;
        this.ersattningsrad = undefined;
        this.anskaffningsform = undefined;
        this.affarsform = undefined;
        this.avverkningsform = undefined;
        this.namn = undefined;
        this.transportslag = undefined;
        this.kontraktstyp = undefined;
        this.verksamhetsomraden = undefined;
        this.lanKommunDistrikt = undefined;
        this.styrtabellRedovisningshanvisningar = undefined;
    }
}
